// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1f4S0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3LVmB"};